import { render, staticRenderFns } from "./CbxPaymentFrequency.vue?vue&type=template&id=221d6e35&"
import script from "./CbxPaymentFrequency.vue?vue&type=script&lang=ts&"
export * from "./CbxPaymentFrequency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports